/**
 * Prints the content of a given HTML element in a new tab and closes the tab after printing or canceling.
 * @param {React.RefObject} contentRef - The ref to the HTML element to be printed.
 * @param {string} title - Optional title for the print window.
 * @param {string} printStyle - Optional custom CSS styles to override table formatting.
 */
const printContent = (contentRef, title = "Print", styleTable = true) => {
    if (!contentRef.current) {
        console.error("Invalid content reference.");
        return;
    }

    const printContent = contentRef.current.innerHTML;

    // Default table style
    const tableStyle = `
        body { font-family: Arial, sans-serif; margin: 20px; }
        .text-right { text-align: right; }
        .summary-table { width: 50%; float: right; margin-left: 20px; }
        .content-wrapper { width: 100%; overflow: hidden; }
         table { width: 100%; border-collapse: collapse; }
        table, th, td { border: 1px solid #ccc; }
        th { background-color: #f5f5f5; }
        th, td { padding: 8px; text-align: left; }
    `;

     const noTableStyle = `
        body { font-family: Arial, sans-serif; margin: 20px; }
        .text-right { text-align: right; }
        .summary-table { width: 50%; float: right; margin-left: 20px; }
        .content-wrapper { width: 100%; overflow: hidden; }
    `;

    const finalStyle = styleTable ? tableStyle : noTableStyle;

    // Open a new tab
    const printWindow = window.open("", "_blank");

    if (!printWindow) {
        console.error("Failed to open a new window/tab.");
        return;
    }

    printWindow.document.open();
    printWindow.document.write(`
        <html>
            <head>
                <title>${title}</title>
                <style>${finalStyle}</style>
            </head>
            <body>
                ${printContent}
            </body>
        </html>
    `);
    printWindow.document.close();

    printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();

        const closeCheck = setInterval(() => {
            if (printWindow.closed) {
                clearInterval(closeCheck);
            } else if (!printWindow.document.hasFocus()) {
                clearInterval(closeCheck);
                printWindow.close();
            }
        }, 500);
    };
};

export default printContent;
